import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

const CourseCard = ({ course, animationDelay, onClick }) => {
  const priceFormatted = course.price
    ? new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: course.currency || 'XOF',
    }).format(course.price)
    : 'Gratuit';

  const discountedPriceFormatted = course.discounted_price
    ? new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: course.currency || 'XOF',
    }).format(course.price)
    : 'Gratuit';

  return (
    <div className="rounded-lg overflow-hidden cursor-pointer
     h-full group"
      data-anim-child={`slide-up delay-${animationDelay}`} onClick={onClick}>
      <div className="relative rounded-lg overflow-hidden h-[330px]group">
        <img
          src={course.image || "/coursesCards/1.png"}
          alt={course.title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-dark-2 bg-opacity-0 group-hover:bg-opacity-50 flex
                       items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
        </div>

        {course.tags && course.tags.length > 0 && (
          <div className="absolute top-3 px-2 flex justify-between w-full items-center">
            {course.tags.map((tag, index) => (
              <span
                key={index}
                className={`px-3 py-1 items-center rounded-full text-xs w-fit
                  font-medium ${tag === 'POPULAR' ? 'bg-purple-1 dark:bg-purple-300 text-white' :
                    'bg-green-400 dark:bg-green-500 text-dark-1 dark:text-white'
                  }`}
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>

      <div className="p-4">
        <div className="flex items-center mb-2">
          <span className="text-yellow-500 mr-2">{course.rating || 4.5}</span>
          <div className="flex text-yellow-500 mr-2">
            {[...Array(5)].map((_, i) => (
              <FontAwesomeIcon key={i} icon={faStar} className="w-3 h-3" />
            ))}
          </div>
          <span className="text-gray-500 dark:text-gray-300 text-sm">({course.total_reviews || 0})</span>
        </div>

        <h3 className="text-[17px] font-normal text-dark-1 dark:text-white mb-3">{course.title}</h3>

        <div className="grid grid-cols-3 text-sm text-gray-600 dark:text-gray-300 mb-4">
          <div className="flex items-center">
            <img src="/coursesCards/icons/1.svg" alt="Lessons" className="w-4 h-4 mr-1 dark:invert" />
            {course.total_lessons || 0} lesson
          </div>
          <div className="flex items-center">
            <img src="/coursesCards/icons/2.svg" alt="Duration" className="w-4 h-4 mr-1 dark:invert" />
            {course.estimated_duration_hours || 0}h
          </div>
          <div className="flex items-center">
            <img src="/coursesCards/icons/3.svg" alt="Level" className="w-4 h-4 mr-1 dark:invert" />
            {course.difficulty_level || 'Beginner'}
          </div>
        </div>

        <div className="flex justify-between items-center pt-4 border-t border-gray-100 dark:border-gray-700">
          <div className="flex items-center">
            <img src={course.instructor_avatar || "/general/avatar-1.png"} alt={course.instructor_name} className="w-8 h-8 rounded-full mr-2" />
            <span className="text-sm text-gray-700 dark:text-gray-300">{course.instructor_name || 'Ali Tufan'}</span>
          </div>
          <div className="text-right">
            {course.discounted_price && course.discounted_price < course.price ? (
              <>
                <span className="text-gray-400 line-through text-sm mr-2">{priceFormatted}</span>
                <span className="text-dark-1 dark:text-white font-semibold">{discountedPriceFormatted}</span>
              </>
            ) : (
              <span className="text-dark-1 dark:text-white font-semibold">{priceFormatted}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;